export enum EnExpirationType {
    days = 'd',
    hours = 'h',
    minutes = 'm',
    seconds = 's'
}